module.exports = __webpack_public_path__ + "static/media/2-F-1.488fea9b.webp";